import axios from 'axios';

const api = axios.create({ baseURL: 'https://backend.realsstore.shop' });

// Attach Authorization header dynamically from localStorage for each request
api.interceptors.request.use(config => {
  const token = localStorage.getItem('jwt');
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export default api;
